import React from "react";
import Navbar from "./navbar";
import PortfolioHeroSection from "./PortfolioHeroSection";
import AboutSection from "./AboutSection";
import Footer from "./Footer";
import OurProducts from "./OurProducts";
import ClientSuccessStories from "./ClientSuccessStories";

export default function Portfolio() {
  return (
    <>
      <Navbar />
      <PortfolioHeroSection />
      {/* <div className="-mt-16 relative z-20">
        <AboutSection
          heading=" "
          fullWidth
          content="We believe in developing forward-thinking business solutions for Web, Mobile, and Digital Assets, leveraging the latest tech stack like IoT, Cloud, Blockchain, Cloud, DevOps, Data science, Big data and more. Our goal is to drive a positive change with exceptional solutions."
        />
      </div> */}
      <div className="bg-[#03152d]">
        <OurProducts />
        <ClientSuccessStories />
      </div>
      <Footer />
    </>
  );
}